import * as _ from 'lodash';
import { Advertiser } from './Advertiser';
import { Agency } from './Agency';
import { Consultant } from './Consultant';
import { Group } from './Group';
import { Holding } from './Holding';

export class User {
  id: number;
  client_id: number = null;
  agency_id: number = null;
  consultant_id: number = null;
  group_id: number = null;
  holding_id: number = null;
  advertiser_id: number = null;
  type_other: string = null;
  alias: string = null;
  birthdate: string = null;
  company: string = null;
  company_id: string = null;
  company_type: string = null;
  linkedin_url: string = null;
  country_iso: string = null;
  disabled_at: string = null;
  endSubscriptionAt: string = null;
  is_deletable: boolean = null;
  mobile: number;
  newsletter: boolean = null;
  notifications_email: number;
  notifications_fcm: number;
  numLogins: number;
  origin: string = null;
  password: string = null;
  perm_countries: string = null;
  perm_segments: string = null;
  status: string = null;
  updated_at: string = null;
  avatar: string = null;
  firstname: string = null;
  lastname: string = null;
  email: string = null;
  gender: string = null;
  phone: string = null;
  created_at: string = null;
  email_verified_at: string = null;
  phone_verified_at: string = null;
  last_login: string = null;
  notification_hash: string = null;
  roles: Array<string> = [];
  permissions: Array<string> = [];

  agency: Agency = null;
  advertiser: Advertiser = null;
  consultant: Consultant = null;
  group: Group = null;
  holding: Holding = null;
  local_contact: boolean = false;
  job_title:string = null;

  constructor(id?: number | Object) {
    if (typeof id == 'object') {
      this.import(id);
    } else {
      this.id = id;
    }
  }

  exists() {
    return !!this.id;
  }

  import(data) {
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        switch (key) {
          case 'roles':
          case 'permissions':
          case 'perm_countries':
          case 'perm_segments':
            break;
          case 'pr':
            try {
              let pr = JSON.parse(atob(data[key]));
              this.roles = pr.roles;
              this.permissions = pr.permissions;
              this.perm_countries = pr.perm_countries;
              this.perm_segments = pr.perm_segments;
            } catch (e) {}
            break;
          case 'agency':
            this[key] = new Agency(data[key]);
            break;
          case 'advertiser':
            this[key] = new Advertiser(data[key]);
            break;
          case 'consultant':
            this[key] = new Consultant(data[key]);
            break;
          case 'group':
            this[key] = new Group(data[key]);
            break;
          case 'holding':
            this[key] = new Holding(data[key]);
            break;
          default:
            this[key] = data[key];
        }
      }
    }
  }

  getIdentity(mode = 'alias') {
    return `${this.firstname} ${this.lastname}`;
  }

  hasRole(roles = []) {
    if (!this.roles || this.roles.length == 0) {
      return false;
    }
    return _.intersection(this.roles, roles).length > 0;
  }

  hasPermission(perms = []) {
    if (!this.permissions || this.permissions.length == 0) {
      return false;
    }
    return _.intersection(this.permissions, perms).length > 0;
  }
}
